import useAxios from "src/core/shared/hooks/useAxios";
import {
  RequestConfig,
  UseApiRequest,
  EndpointConfig
} from "src/core/shared/api/config.api";
import { IPriceList } from "src/core/shared/api/price-change.api";
import {
  FilterParams,
  PaginatedData,
  PaginatedParams
} from "src/library/utils";

export type ListPriceListsParams = { pagination: PaginatedParams<IPriceList>; filters: FilterParams<IPriceList> };
export type CreatePriceListParams = Pick<IPriceList, "name" | "code">;
export type UpdatePriceListParams = Pick<IPriceList, "id" | "name" | "code">;

export enum PricesRequestName {
  GET_PRICE_LIST = "GET_PRICE_LIST",
  LIST_PRICE_LISTS = "LIST_PRICE_LISTS",
  CREATE_PRICE_LIST = "CREATE_PRICE_LIST",
  UPDATE_PRICE_LIST = "UPDATE_PRICE_LIST",
  DELETE_PRICE_LIST = "DELETE_PRICE_LIST",
  EXPORT_PRICE_CODE = "EXPORT_PRICE_CODE"
}

type PricesEndpointConfig = {
  [PricesRequestName.GET_PRICE_LIST]: EndpointConfig<
    {priceCodeId: number},
    IPriceList
  >,
  [PricesRequestName.LIST_PRICE_LISTS]: EndpointConfig<
    ListPriceListsParams,
    PaginatedData<IPriceList>
  >,
  [PricesRequestName.CREATE_PRICE_LIST]: EndpointConfig<
    CreatePriceListParams,
    IPriceList
  >,
  [PricesRequestName.UPDATE_PRICE_LIST]: EndpointConfig<
    UpdatePriceListParams,
    IPriceList
  >,
  [PricesRequestName.DELETE_PRICE_LIST]: EndpointConfig<
    {id: number},
    IPriceList
  >,
  [PricesRequestName.EXPORT_PRICE_CODE]: EndpointConfig<
    {priceCodeId: number | null},
    {message: string}
  >
};

const BASE_URL_SEEDLESS = `${process.env.REACT_APP_API_URL}/seedless/price-codes`;
const BASE_URL_CORE = `${process.env.REACT_APP_API_URL}/core/price-codes`;

/**
 * price lists API
 */
const requests: RequestConfig<PricesEndpointConfig> = {
  [ PricesRequestName.GET_PRICE_LIST ]: ({ priceCodeId }) => ({
    url: `${BASE_URL_SEEDLESS}/${priceCodeId}`,
    method: "GET"
  }),
  [ PricesRequestName.LIST_PRICE_LISTS ]: ({ ...params }) => ({
    url: `${BASE_URL_CORE}`,
    method: "GET",
    params
  }),
  [ PricesRequestName.CREATE_PRICE_LIST ]: ({ ...data }) => ({
    url: `${BASE_URL_SEEDLESS}`,
    method: "POST",
    data
  }),
  [ PricesRequestName.UPDATE_PRICE_LIST ]: ({ ...data }) => ({
    url: `${BASE_URL_SEEDLESS}/${data.id}`,
    method: "PATCH",
    data
  }),
  [ PricesRequestName.DELETE_PRICE_LIST ]: ({ id }) => ({
    url: `${BASE_URL_SEEDLESS}/${id}`,
    method: "DELETE"
  }),
  [ PricesRequestName.EXPORT_PRICE_CODE ]: ({ priceCodeId }) => ({
    url: `${BASE_URL_CORE}/${priceCodeId}/export`,
    method: "GET"
  })
};

export const usePricesApi: UseApiRequest<PricesEndpointConfig> = name => useAxios(requests[ name ], name);
